import { render, staticRenderFns } from "./DragList.vue?vue&type=template&id=7b9db88d&scoped=true&"
import script from "./DragList.vue?vue&type=script&lang=js&"
export * from "./DragList.vue?vue&type=script&lang=js&"
import style1 from "./DragList.vue?vue&type=style&index=1&id=7b9db88d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b9db88d",
  null
  
)

export default component.exports